import BannerTemplate from '../DefaultBanner/index'
import { report } from '@src/common/decorators'

export default class DefaultBannerFix extends BannerTemplate {
    constructor(props) {
        super(props)
        //this.campaign = props.campaign || {}
    }
    
    @report([{
        proxySelector: '.jumpUrl',
        targetSelector: '.jumpUrl',
        eventName: 'click',
        action: function (...args) {
            this.platform.clickInstall(...args)
        },
        params:{
            template:"banner" // 传入模版类型
        }
    }])
    adShowed(res) {
        console.log('fix banner showed')
        this.windowStartPoint = res&&res.param || {};
    }
}